<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@/mixins/shared/formInput";
import Input from "@/pages/components/form/input-only/pictures.vue";

export default {
	mixins: [formInput],
	components: {FormGroup, Input},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'type': {
			type: String,
			default: 'text'
		},
		'label': {
			type: String,
			required: false
		}
	}
}
</script>

<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label">{{ label }}</template>
		
		<Input
			v-bind="$attrs"
			:form="form"
			:name="name"
			:type="type"
			:id="renderedId"
			:model-value="modelValue"
			@update:modelValue="changeModelValueTo"
		/>
	</FormGroup>
</template>